import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router";
import useKidListFunctionality from "../../../../customHooks/kidListHook";
import { useDispatch, useSelector } from "react-redux";
import useLangTranslation from "../../../../customHooks/languageProvider";
import { copySettingDetails } from "../../../AxiosRtk/CopySetting";
import useCopySetting from "./useCopySetting";
import useFirebase from "../../../../../useFirebase";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import Select from "react-select";
import { setShowMessage, setErrorInfo } from "../../../AxiosRtk/successMessage";
import KidImage from "../../../../shared/KidImage/KidImage";
import { useDashboardDataProvider } from "../../../../customHooks/dashboardDataProvider";

const CopySettings = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [kidData, setKidData] = useState(false);
  const [selectedDestinations, setSelectedDestinations] = useState([]);
  const [allDestinations, setAllDestinations] = useState([]);
  const [sourceDeviceData, setSourceDeviceData] = useState({});
  const { getLangTranslation } = useLangTranslation();
  const [deviceStatus, setDeviceStatus] = useState("");
  const { handleDeviceSelection } = useDashboardDataProvider();
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );

  const { kidDevicesList, kidList, selectedKidId, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { getImage } = useKidListFunctionality();
  const handleGoBack = () => {
    history.goBack();
  };
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const { handleCopyData } = useCopySetting(
    selectedDeviceData?.ID,
    sourceDeviceData,
    setSourceDeviceData
  );

  const { getCollectionData } = useFirebase(selectedDeviceData?.ID);

  useEffect(() => {
    setKidData(kidList?.find((item, index) => item?.ID == selectedKidId));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (setRulesData) {
      setSourceDeviceData(setRulesData);
    }
  }, [setRulesData]);

  useEffect(() => {
    if (selectedDeviceData) {
      getCollectionData(selectedDeviceData?.ID);
      setAllDestinations(
        kidList
          ?.map((item) => item?.KidsDevices)
          ?.flat(Infinity)
          ?.map((item) => item?.KidsDeviceId)
          ?.filter((item) => item && item != selectedDeviceData?.ID)
      );
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  const handleSelectAllChange = () => {
    if (selectedDestinations.length === allDestinations.length) {
      setSelectedDestinations([]);
    } else {
      setSelectedDestinations(allDestinations);
    }
  };

  const handleCheckboxChange = (selected) => {
    if (selectedDestinations.includes(selected)) {
      setSelectedDestinations(
        selectedDestinations.filter((id) => id !== selected)
      );
    } else {
      setSelectedDestinations([...selectedDestinations, selected]);
    }
  };

  useEffect(() => {
    // console.log(selectedDestinations);
  }, [selectedDestinations]);

  const handleSubmit = () => {
    if (selectedDestinations.length < 1) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "DEVICE_NOT_SELECTED",
          defaultTitle: "Device not selected",
        })
      );
      return;
    }
    let payload = {
      deviceId: selectedDeviceData?.ID,
      destinationDeviceId: selectedDestinations,
    };
    // handleCopyData(selectedDestinations);
    copySettingDetails(payload)
      .then((response) => {
        if (response) {
          // console.log(response?.data);
          handleCopyData(selectedDestinations);
          setSelectedDestinations([]);

          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: "Settings saved successfully",
              message: "APP_STATUS_UPDATED",
            })
          );
        }
      })
      .catch((error) => console.error(`Error:${error}`));
  };

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <Link
                    to="/"
                    className="text-blue-900 fs-5"
                    onClick={handleGoBack}
                  >
                    <i className="icon-arrow-left" />
                  </Link>
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation("COPY_SETTINGS", "Copy settings")}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imageUrl={kidData?.image} gender={kidData?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>

                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon-nudity">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div
            className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
            role="alert"
          >
            <i className="icon-info-one fs-5" />
            {getLangTranslation(
              "COPY_SETTINGS_FEATURE_COPY_INFO",
              "This feature will allow you to copy the settings you did on one child or a device to many devices or many children."
            )}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
          <div
            className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
            role="alert"
          >
            <i className="icon-info fs-5" />
            {getLangTranslation(
              "COPY_SETTING_FEATURE_NOT_COPY_INFO",
              "Copy settings will not copy settings done app by app, but only what you set in app categories, as each device has different and specific apps."
            )}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
          <div
            className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
            role="alert"
          >
            <i className="icon-info fs-5" />
            {getLangTranslation(
              "COPY_SETTING_FEATURE_NOT_COPY_SCREENSHOT_SETTING_INFO",
              "Copy settings will not copy settings done on screenshot monitoring on take screenshot when using the following apps and the interval time also."
            )}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
          <div className="d-flex flex-wrap align-items-center gap-3">
            <div className="form-check me-auto">
              <input
                className="form-check-input"
                id="enableScreenshot"
                type="checkbox"
                checked={
                  selectedDestinations.length > 0 &&
                  selectedDestinations.length === allDestinations.length
                }
                onChange={handleSelectAllChange}
              />
              <label className="form-check-label" htmlFor="enableScreenshot">
                {getLangTranslation("SELECT_ALL_DEVICES", "Select all devices")}
              </label>
            </div>
            <button className="btn btn-primary" onClick={handleSubmit}>
              <span className="btn-upper-case">
                {getLangTranslation("COPY_SETTINGS", "Copy settings")}
              </span>
            </button>
          </div>
          <hr className="mt-6 mb-0"></hr>
          {kidList
            ?.filter(
              (data) =>
                data?.KidsDevices?.filter(
                  (itm) =>
                    itm?.KidsDeviceId &&
                    itm?.KidsDeviceId != selectedDeviceData?.ID
                ).length > 0
            )
            ?.map((item, index) => (
              <div
                className="inline-list-wrap separator space-24 bg-gray-300 p-6 border-bottom"
                key={item.ID}
              >
                <div className="list-item">
                  <span className="icon-wrap icon-rounded me-2 p-0">
                    <img
                      src={getImage(item?.image, item?.gender)}
                      alt=""
                      className="img-fluid rounded-circle"
                      onError={(event) => {
                        event.target.onerror = null;
                        event.target.src = getImage(item?.image, item?.gender);
                      }}
                    />
                  </span>
                  <div className="list-content">
                    <h5 className="text-blue-900 mb-0">{item?.childName}</h5>
                  </div>
                </div>
                {item?.KidsDevices?.filter(
                  (itm) =>
                    itm?.KidsDeviceId &&
                    itm?.KidsDeviceId != selectedDeviceData?.ID
                )?.map((deviceData, deviceIndex) => (
                  <div className="list-item" key={deviceIndex}>
                    <div className="form-check ">
                      <input
                        className="form-check-input"
                        id="enableScreenshot"
                        type="checkbox"
                        checked={selectedDestinations.includes(
                          deviceData.KidsDeviceId
                        )}
                        onChange={() =>
                          handleCheckboxChange(deviceData.KidsDeviceId)
                        }
                      />
                      <label
                        className="form-check-label text-small"
                        htmlFor="enableScreenshot"
                      >
                        {deviceData?.Name}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default CopySettings;
